"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = exports.DataSheetOutputSchema = exports.XlsxFileInsertionConfigSchema = exports.isAthenaQueryFileInsertionConfig = exports.XlsxAthenaQueryFileInsertionConfigSchema = exports.FileInsertionTypeIterable = exports.DataOutputTypeIterable = void 0;
const _imports_1 = require("../../_imports");
exports.DataOutputTypeIterable = [
    'dataCellObject',
    'fileInsertion',
    'imageFileInsertion',
];
// *******************************
// ***  File Insertion Config  ***
// *******************************
exports.FileInsertionTypeIterable = [
    'rawMasterLoanTape',
    'rawAssignedLoanTape',
    'rawCovenantLoanTape',
    'rawRepaymentTape',
    'rawSupplementalTape',
    'generatedMasterLoanTape',
    'generatedAssignedLoanTape',
    'generatedCovenantLoanTape',
    'generatedRepaymentTape',
    'generatedSupplementalTape',
    'intermediateTape',
    'extendedResponseTape',
    'newlyAssignedExtendedResponseTape',
    'borrowingBaseReserve',
    'statementDailySummary',
    'bankAccountScreenshot',
    'athenaQuery',
];
// Zod schemas for Xlsx types
const NumberCoordinatesSchema = _imports_1.z.object({
    row: _imports_1.z.number(),
    column: _imports_1.z.number(),
});
const DataCellObjectSchema = _imports_1.z.object({
    excelCoordinate: _imports_1.z.string(),
    numberCoordinates: NumberCoordinatesSchema,
    value: _imports_1.Utils.PrimitiveStruct,
});
const DataCellObjectConfigSchema = _imports_1.z.object({
    data: _imports_1.z.array(DataCellObjectSchema),
});
// FileInsertionType without 'statementDailySummary'
const FileInsertionTypeDefaultIterable = [
    'rawMasterLoanTape',
    'rawAssignedLoanTape',
    'rawCovenantLoanTape',
    'rawRepaymentTape',
    'rawSupplementalTape',
    'generatedMasterLoanTape',
    'generatedAssignedLoanTape',
    'generatedCovenantLoanTape',
    'generatedRepaymentTape',
    'generatedSupplementalTape',
    'intermediateTape',
    'extendedResponseTape',
    'newlyAssignedExtendedResponseTape',
    'borrowingBaseReserve',
    'bankAccountScreenshot',
];
const BaseFileInsertionConfigSchema = _imports_1.z.object({
    loanProductId: _imports_1.z.string().optional(),
    reportingDateFormula: _imports_1.z.string(),
    startingExcelCoordinate: _imports_1.z.string(),
    artifactSlug: _imports_1.z.string().optional(),
    bankAccountId: _imports_1.z.string().optional(),
});
const FileInsertionConfigDefaultSchema = BaseFileInsertionConfigSchema.extend({
    fileType: _imports_1.z.enum(FileInsertionTypeDefaultIterable),
});
const FileInsertionConfigStatementDailySummarySchema = BaseFileInsertionConfigSchema.extend({
    loanProductId: _imports_1.z.never().optional(), // Matches `loanProductId?: never`
    fileType: _imports_1.z.literal('statementDailySummary'),
    requiresLatestStatementForPeriod: _imports_1.z.boolean(),
    statementStartDateFormula: _imports_1.z.string(),
    statementEndDateFormula: _imports_1.z.string(),
});
exports.XlsxAthenaQueryFileInsertionConfigSchema = BaseFileInsertionConfigSchema.extend({
    loanProductId: _imports_1.z.never().optional(),
    fileType: _imports_1.z.literal('athenaQuery'),
    athenaQueryName: _imports_1.z.string(),
});
const isAthenaQueryFileInsertionConfig = (config) => exports.XlsxAthenaQueryFileInsertionConfigSchema.safeParse(config).success;
exports.isAthenaQueryFileInsertionConfig = isAthenaQueryFileInsertionConfig;
exports.XlsxFileInsertionConfigSchema = _imports_1.z.discriminatedUnion('fileType', [
    FileInsertionConfigDefaultSchema,
    FileInsertionConfigStatementDailySummarySchema,
    exports.XlsxAthenaQueryFileInsertionConfigSchema,
]);
// Output schemas
const DataCellObjectOutputSchema = _imports_1.z.object({
    name: _imports_1.z.string(),
    type: _imports_1.z.literal('dataCellObject'),
    config: DataCellObjectConfigSchema,
});
const XlsxFileInsertionOutputSchema = _imports_1.z.object({
    name: _imports_1.z.string(),
    type: _imports_1.z.literal('fileInsertion'),
    config: exports.XlsxFileInsertionConfigSchema,
});
const ImageFileInsertionOutputSchema = _imports_1.z.object({
    name: _imports_1.z.string(),
    type: _imports_1.z.literal('imageFileInsertion'),
    config: exports.XlsxFileInsertionConfigSchema,
});
exports.DataSheetOutputSchema = _imports_1.z.discriminatedUnion('type', [
    DataCellObjectOutputSchema,
    XlsxFileInsertionOutputSchema,
    ImageFileInsertionOutputSchema,
]);
// Compile-time assertion for DataSheetOutput
/**
 * Output config generally represents high-level XLSX workbook.
 * "template" is optional - where if present, data output will mutate / populate values
 * based on the template, otherwise, will look to create own raw file
 */
// Inline TemplateConfig schema to avoid forward reference
const XlsxTemplateConfigSchema = _imports_1.z.object({
    name: _imports_1.z.string(),
    s3Path: _imports_1.z.string(),
});
exports.ConfigSchema = _imports_1.z.object({
    name: _imports_1.z.string(),
    sheets: _imports_1.z.array(exports.DataSheetOutputSchema),
    template: XlsxTemplateConfigSchema.optional(),
});
// Compile-time assertion for Config
//# sourceMappingURL=Xlsx.js.map